module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-15-bae9e6e9980124eb57f002359f3887d4.svg";